import React, { useState, useEffect } from 'react';
import {
    Paper,
    FormControl,
    TextField,
    //Select,
    MenuItem,
    Typography,
    FormGroup,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import axios from 'axios';
import Common from '../Common';
import { withCookies } from 'react-cookie';
import CreateButton from './CreateQRButton';
import PreViewQr from './PreViewQr';
import Select from 'react-select'

const useStyles = makeStyles({
    paper: {
        marginTop: '5px',
        minWidth: 900,
        textAlign: 'center',
        justifyContent: 'center',
    },
    selectKubunArea: {
        marginTop: '30px',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight:'82px',
    },
    inputAddress: {
        marginTop: '30px',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight:'30px',
        marginLeft:'auto'
    },
    inputNickName: {
        marginTop: '30px',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight:'100px',
        marginLeft:'auto'
    },
    attention: {
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft:'200px',
    },
    categorySelect:{
        margin: '0px 7px 0px 22px',
    },
    conditionLeft: {
        width: '420px',
        fontSize:'20px',
        textAlign:'left',
    },
    deletionFlgList:{
        borderBottom: 'solid 2px #FFF',
        height:'40px',
        fontSize:'19px'
    },
    categoryName:{
        borderBottom: 'solid 2px #FFF',
        fontSize:'19px',
        marginRight: '300px',
    },
    title:{
        marginLeft: '30px',
        marginTop: '30px',
        justifyContent: 'center',
        textAlign:'center'
    },
    inputKeyword:{
        fontSize:'20px',
        margin: '0px 0px 10px 100px',
        width: 200
    },
    left:{
        display: 'inline-block',
    },
    marginAuto:{
        margin: '0px auto 10px auto'
    },
    require:{
        margin:'20px 0px 0px 60px',
        fontSize:'16px'
    },
    require2:{
        margin:'10px 0px 20px 60px',
        fontSize:'16px'
    },
    resize:{
        fontSize:'17px'
    }
});
const QR = withCookies((props) => {
    const classes = useStyles();
    const [chatCategoryList, setChatCategoryList] = useState([]);
    const [displayChatCategoryList, setDisplayChatCategoryList] = useState([]);
    const [displayCategory, setDisplayCategory] = useState([]);
    const [selectedChatcategoryId, setSelectedChatcategoryId] = useState('');
    const [address, setAddress] = useState('');
    const [nickName, setNickName] = useState('');
    const [previewFlg, setPreviewFlg] = useState(false);
    const [liffUrl, setLiffUrl] = useState('');
    const [encodedAddress, setEncodedAddress] = useState('');
    const [displayNickName, setDisplayNickName] = useState(false);

    const { cookies } = props;
    const commonNameObj = cookies.get('COMMON_NAME_OBJ');
    document.title = commonNameObj !== undefined ? commonNameObj.CHAT_NAME : '1対1チャット';
    const printNameObj = cookies.get('PRINT_NAME_OBJ');
    const chatName = commonNameObj !== undefined ? commonNameObj.CHAT_NAME : '1対1チャット';
    const kubunName = commonNameObj !== undefined ? commonNameObj.KUBUN_NAME : 'チャットカテゴリ';
    const addressName = commonNameObj !== undefined ? commonNameObj.ADDRESS_NAME : '認証番号';
    const userName = commonNameObj !== undefined ? commonNameObj.USER_NAME : 'ニックネーム';
    const title = printNameObj !== undefined ? printNameObj.PRINT_TITLE : 'QRコード発行';
    const printAddressName = printNameObj !== undefined ? printNameObj.PRINT_ADDRESS_NAME : 'お客様番号';
    const printUserName = printNameObj !== undefined ? printNameObj.PRINT_USER_NAME : userName;
    const printDescription = printNameObj !== undefined ? printNameObj.PRINT_DESCRIPTION : '';
    const printTerms = printNameObj !== undefined ? printNameObj.PRINT_TERMS : '';
    const printSize = printNameObj !== undefined ? printNameObj.PRINT_SIZE : 'A4';
    const printNameHonorifics = printNameObj !== undefined ? printNameObj.PRINT_NAME_HONORIFICS : '様';
    const nameObj = {
        'CHAT_NAME' : chatName,
        'KUBUN_NAME': kubunName,
        'USER_NAME' : userName,
        'ADDRESS_NAME': addressName,
        'PRINT_TITLE': title,
        'PRINT_ADDRESS_NAME': printAddressName,
        'PRINT_USER_NAME': printUserName,
        'PRINT_DESCRIPTION': printDescription,
        'PRINT_TERMS': printTerms,
        'PRINT_SIZE': printSize,
        'PRINT_NAME_HONORIFICS': printNameHonorifics
    };

    //-----------------------------------------------------------------
    //              ページに格納するデータの取得
    //-----------------------------------------------------------------
    function getCategoryData() {
        if(chatCategoryList.length === 0){
            const token = cookies.get('token');
            const jichitaiToken = cookies.get('x-jichitai-token');
            const jichitaiId = cookies.get('x-jichitai-jichitaiid');
            const supportedPersonId = cookies.get('supportedPersonId');
            axios.get(
            `${Common.apiServerUrl()}/api/counseling/getResponsibleKubun`,
            {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'x-suppportcenter-token': token,
                    'x-jichitai-jichitaiid': jichitaiId,
                    'x-jichitai-token': jichitaiToken,
                },
                params: {
                    supportedPersonId,
                    qr:true
                }
            })
            .then(Common.handleErrors)
            .then((getResponsibleKubunResponse) => {
                if (getResponsibleKubunResponse.success) {
                    //担当区分が返却された場合のみ割り当てる
                    if (getResponsibleKubunResponse.getResponsibleKubunArray.length !== 0){
                        const categoryArray = getResponsibleKubunResponse.getResponsibleKubunArray.filter((d) => d.counselingKubunId !== '00' && d.counselingKubunId !== 'all');
                        const selectArray = [
                            {
                                value: '',
                                label: '---'
                            }
                        ];
                        categoryArray.map((d) => {
                            selectArray.push(
                                {
                                    value: d.counselingKubunName,
                                    label: d.counselingKubunName
                                }
                            )
                        });
                        setDisplayChatCategoryList(selectArray);
                        setChatCategoryList(categoryArray);
                        const displayNickNameFlg = getResponsibleKubunResponse.displayNickName === 'TRUE' ? true : false;
                        setDisplayNickName(displayNickNameFlg);
                    }
                    //対応：ここのsetStateは担当区分がない場合にはERRORになる
                } else {
                    alert(`code : [${getResponsibleKubunResponse.code}]\nmessage : ${getResponsibleKubunResponse.error_usermsg}`);
                }
            })
            .catch((err) => {
                console.log(err);
                if (Object.keys(err).indexOf('data') !== -1) {
                    alert(`code : [${err.code}]\nmessage : ${err.error_usermsg}`);
                } else {
                    alert('code : [getResponsibleKubun]\nmessage : エラーが発生しました。サポートに連絡してください。');
                }
            });
        }
    }

    function handleCategoryChange(category){
        if(category.value !== ''){
            const selectCategory = chatCategoryList.filter((d) => d.counselingKubunName === category.label);
            setDisplayCategory([
                {
                    value: selectCategory[0].counselingKubunName,
                    label: selectCategory[0].counselingKubunName
                }
            ]);
            setSelectedChatcategoryId(selectCategory[0].counselingKubunId);
        }
        else{
            setDisplayCategory([]);
            setSelectedChatcategoryId('');
        }
    }

    useEffect(() => {
        if(cookies.get('supporterFullName') === undefined || cookies.get('supporterFullName') === ''){
            window.location.href = '/';
        }
        else if(chatCategoryList.length === 0) getCategoryData();
    },[]);

    return (
        <React.Fragment>
            { !previewFlg && (
                <div elevation={3} className={classes.paper} >
                    <div className={classes.left}>
                        <Typography className={classes.title} variant="h4" component="p">
                            {title}
                        </Typography>
                        <Paper elevation={2} variant="outlined" className={classes.paper}></Paper>
                        <FormGroup className={classes.inputAddress} row>
                            <div className={classes.require}>
                                {`・QRコードを発行する場合は、【${kubunName}】を選択し、【${addressName}】【${userName}】を入力してください。`}
                            </div>
                        </FormGroup>
                        <FormGroup className={classes.inputAddress} row>
                            <div className={classes.require2}>
                                {`・既に発行済みのQRコードを表示する場合は、【${kubunName}】を選択し、【${addressName}】を入力してください。`}
                            </div>
                        </FormGroup>
                        <FormGroup className={classes.selectKubunArea} row>
                            <Typography variant="body1" className={classes.inputKeyword}>
                                {`${kubunName}：`}
                            </Typography>
                            <div className={classes.marginAuto}>
                                <React.Fragment>
                                    <FormControl className={classes.categorySelect}>
                                        <Select
                                            id="multiple-checkbox-johoKubun"
                                            value={displayCategory}
                                            options={displayChatCategoryList}
                                            className={classes.conditionLeft}
                                            isSearchable
                                            variant="outlined"
                                            onChange={handleCategoryChange}
                                            placeholder={'絞り込み検索'}
                                            noOptionsMessage={() => '検索結果が見つかりませんでした'}
                                        >
                                        </Select>
                                    </FormControl>
                                </React.Fragment>
                            </div>
                        </FormGroup>
                        <FormGroup className={classes.selectKubunArea} row>
                            <Typography variant="body1" className={classes.inputKeyword}>
                                {`${addressName}：`}
                            </Typography>
                            <div className={classes.marginAuto}>
                                <React.Fragment>
                                    <FormControl className={classes.categorySelect}>
                                        <TextField
                                            id="outlined-basic"
                                            variant="outlined"
                                            className={classes.conditionLeft}
                                            margin="normal"
                                            InputProps={{
                                                style: {
                                                    fontSize: 18,
                                                },
                                            }}
                                            value={address}
                                            required={true}
                                            onChange={(event) => setAddress(event.target.value)}
                                        />
                                    </FormControl>
                                </React.Fragment>
                            </div>
                        </FormGroup>
                        <FormGroup className={classes.selectKubunArea} row>
                            <Typography variant="body1" className={classes.inputKeyword}>
                                {`${userName}：`}
                            </Typography>
                            <div className={classes.marginAuto}>
                                <React.Fragment>
                                    <FormControl className={classes.categorySelect}>
                                        <TextField
                                            id="outlined-basic"
                                            variant="outlined"
                                            className={classes.conditionLeft}
                                            InputProps={{
                                                style: {
                                                    fontSize: 18,
                                                },
                                            }}
                                            margin="normal"
                                            value={nickName}
                                            onChange={(event) => setNickName(event.target.value)}
                                        />
                                    </FormControl>
                                </React.Fragment>
                            </div>
                        </FormGroup>
                        <FormGroup className={classes.selectKubunArea} row>
                            <CreateButton
                                categoryId={selectedChatcategoryId}
                                categoryName={displayCategory}
                                address={address}
                                nickName={nickName}
                                nameObj={nameObj}
                                setPreviewFlg={setPreviewFlg}
                                setLiffUrl={setLiffUrl}
                                setNickName={setNickName}
                                setEncodedAddres={setEncodedAddress}
                            >
                            </CreateButton>
                        </FormGroup>
                    </div>
                </div>
            )}
            { previewFlg && (
                <PreViewQr
                    categoryId={selectedChatcategoryId}
                    categoryName={displayCategory}
                    encodedAddress={encodedAddress}
                    liffUrl={liffUrl}
                    nickName={nickName}
                    nameObj={nameObj}
                    displayNickName={displayNickName}
                    setPreviewFlg={setPreviewFlg}
                    setNickName={setNickName}
                ></PreViewQr>
            )}
        </React.Fragment>
    );
});

export default withCookies(QR);
